import styled from '@emotion/styled';
import { DESKTOP_TOP_HEIGHT, MODIFIER_IS_OPEN } from '../../constants';

const dropDown = 'dropdown';
export const contentWrapper = `${dropDown}__content`;
export const dropDownAccessibilityButton = 'drop-down-accessibility-button';
export const summaryCaret = 'summary-caret';
export const accountIconClass = 'account-icon';

export const StyledDiv = styled.div`
  position: absolute;
  min-width: 240px;
  right: 0;
  top: ${DESKTOP_TOP_HEIGHT}px;
  background: var(--podium-cds-color-bg-primary);
  min-height: 200px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-20px);
  transition: opacity 200ms;
  border-radius: 0 0 8px 8px;
  z-index: 100;

  &.${MODIFIER_IS_OPEN} {
    opacity: 1;
    visibility: visible;
    transform: translateY(0px);
    transition: opacity 200ms, visibility 0s, transform 250ms ease;
  }

  .${contentWrapper} {
    padding-top: 20px;
    padding-left: 15px;
  }
`;

export const StyledDetails = styled.details`
  .${dropDownAccessibilityButton} {
    display: flex;
    align-items: center;
    opacity: 0;
    svg {
      width: 12px;
    }
    &:focus {
      opacity: 1;
      transition: transform ease, opacity 500ms;
    }
  }
  .${accountIconClass} {
    width: 0px;
  }
  .${accountIconClass}:focus {
    width: auto;
  }
  .${summaryCaret} {
    // svg icon will trigger a mouseleave event without this style
    pointer-events: none;
  }
  /** hides the default arrow on some browsers (safari) */
  > summary::-webkit-details-marker {
    display: none;
  }
`;
